export default "__VITE_ASSET__BkL2$GDD__"